import React from 'react';
import { GlassContainer } from './GlassContainer';
import { TSizes } from '../constants/sizes';

export const SkillCard = ({ skill }) => {
  const { title } = skill || {};

  return (
    <GlassContainer
      radius={TSizes.radiusPill || 999}
      style={{
        padding: '10px 16px',
        background: 'rgba(255, 255, 255, 0.08)',
        border: '1px solid rgba(255, 255, 255, 0.18)',
        backdropFilter: 'blur(10px)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'auto'
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '8px'
        }}
      >
        {/* <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="var(--text-primary)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
          <path d="M14 2v4a2 2 0 0 0 2 2h4" />
          <path d="M10 9H8" />
          <path d="M16 13H8" />
          <path d="M16 17H8" />
        </svg> */}

        <span
          style={{
            color: 'var(--text-primary)',
            fontSize: '14px',
            fontWeight: '700',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            lineHeight: '1'
          }}
        >
          {title}
        </span>
      </div>
    </GlassContainer>
  );
};
